(function () {
  'use strict';

  function initTestimonials(section) {
    if (section.dataset.testimonialsInit === 'true') return;
    section.dataset.testimonialsInit = 'true';

    const slides = section.querySelectorAll('[data-slide]');
    const dots = section.querySelectorAll('[data-testimonials-dot]');
    const prev = section.querySelector('[data-testimonials-prev]');
    const next = section.querySelector('[data-testimonials-next]');
    const total = slides.length;

    if (total === 0) return;

    let currentIndex = 0;
    let autoplayTimer = null;

    const autoplay = section.dataset.autoplay === 'true';
    const autoplaySeconds = parseInt(section.dataset.autoplaySeconds, 10) || 7;

    // On desktop show 2 cards at a time; on mobile only 1
    function visiblePerView() {
      return window.matchMedia('(min-width: 750px)').matches ? 2 : 1;
    }

    function setActive(index) {
      currentIndex = (index + total) % total;
      const perView = visiblePerView();
      const activeIndices = new Set();
      for (let i = 0; i < perView; i++) {
        activeIndices.add((currentIndex + i) % total);
      }
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', activeIndices.has(i));
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === currentIndex);
      });
    }

    function nextSlide() { setActive(currentIndex + 1); }
    function prevSlide() { setActive(currentIndex - 1); }

    function startAutoplay() {
      if (!autoplay || total < 2) return;
      stopAutoplay();
      autoplayTimer = setInterval(nextSlide, autoplaySeconds * 1000);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    if (prev) {
      prev.addEventListener('click', () => {
        prevSlide();
        startAutoplay();
      });
    }
    if (next) {
      next.addEventListener('click', () => {
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        setActive(i);
        startAutoplay();
      });
    });

    // Pause on hover (desktop)
    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    // Pause when off-screen
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) startAutoplay();
          else stopAutoplay();
        });
      }, { threshold: 0.2 });
      io.observe(section);
    } else {
      startAutoplay();
    }

    // Keyboard navigation when section is focused
    section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); prevSlide(); startAutoplay(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); nextSlide(); startAutoplay(); }
    });

    // Re-render visible cards on viewport change (1 → 2 cards on resize)
    window.addEventListener('resize', () => setActive(currentIndex), { passive: true });

    // Initial render to make sure correct count of cards is visible
    setActive(0);
  }

  function boot() {
    document.querySelectorAll('[data-v2-testimonials]').forEach(initTestimonials);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('[data-v2-testimonials]');
    if (section) initTestimonials(section);
  });
})();
